import _ from 'axios'
import router from "@/common/router/index";
import store from 'store2';
// import { stringify } from 'qs'
import {
	Message,
	Notification
} from 'element-ui'
import {
	codeMessage,
	CODE
} from './config'


const axios = _.create({
	// baseURL: '',
	baseURL: process.env.VUE_APP_PROXY,
	headers: {
		'Content-Type': 'application/json;charset=UTF-8'
	}
})

axios.interceptors.request.use(cfg => {
	const loginToken = localStorage.getItem('token')
	cfg.headers['Authenticator'] = loginToken
	return cfg
}, (err) => [err.toString()])

axios.interceptors.response.use(res => {
	const {
		data: {
			data,
			code,
			message = ''
		},
		status
	} = res
	if (status !== 200) {
		return [`连接失败 code:${ status }`]
	}

	if (code < 0) {
		Notification.error({
			title: '授权失败',
			message: "登录超时或该账号在其他地方登录,将跳转至首页",
			showClose: false
		});
		// store.clearAll()
		localStorage.removeItem('token')
		localStorage.removeItem('user_info')
		router.replace('/login')
		return [message]
	} else if (code !== CODE.success) {
		// 播放页面报错内容不显示出来
		if (res.config.url != 'study/report') {
			Message.error(message)
		}
		return [message]
	}

	return [null, data, code, message]
}, err => {
	const {
		response
	} = err

	if (!response) {
		return ['未连接到服务器']
	}

	// 还是需要返回错误原信息,因为接口需要传递发送信息与接口的信息
	if (response && response.status) {
		return [codeMessage(response.status)]
	}
})

export default axios